<template>
  <custom-dialog
    color="primary"
    icon="search"
    ref="dialog"
    store-modal
    title="Recherche"
  >
    <custom-technician-selector-table
      :affectedTech="affectedTech"
      :entity-id="entity_nav_full_id"
      @input="handleAssignClick"
      :property-id="propertyId"
      :request="item"
      v-if="$store.getters['modal/isOpen']"
    />
    <template v-slot:actions>
      <span v-if="affectedTech || loading" class="caption font-weight-bold">
        {{ generateMessage('tech_search.affected_tech') }} :
      </span>
      <v-chip
        v-if="affectedTech && !affectLoading"
        class="caption text-end"
        close
        @click:close="handleRemoveClick"
      >
        {{ affectedTech.full_name }}
      </v-chip>
      <div class="caption" v-else-if="loading || affectLoading">
        Chargement..
      </div>
      <div><p>&nbsp;</p></div>
      <transmit-dialog
        v-if="affectedTech"
        :is-mobile-user="affectedTech.mobile_user"
        :name="affectedTech.full_name"
        :phone-type="affectedTech.phone_type"
        :requestId="requestId"
        @success="cancel"
        class="buttonTrans"
        style="margin-left: 20px;"
        icon="mdi-transfer-right"
      />
      <v-btn class="mx-2" small @click="cancel">
        {{ generateMessage('tech_search.close') }}
      </v-btn>
    </template>
  </custom-dialog>
</template>

<script>
import { affectTechnician } from '@/services/api/internal/requestActions/affectation.api';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';
import CustomDialog from '@/components/dialogs/CustomDialog';
import CustomTechnicianSelectorTable from '@/components/selects/technician/CustomTechnicianSelectorTable';
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import { setDispActive } from '@/services/api/internal/requestActions/selfAssign.api';
import TransmitDialog from '@/pages/eDispatch/requestActions/TransmitDialog';

export default {
  name: 'RequestAffectationDialog',
  components: {
    CustomDialog,
    CustomTechnicianSelectorTable,
    TransmitDialog,
  },
  props: {
    entity_nav_full_id: {
      type: String,
      required: true,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    item: {
      type: Object,
      required: false,
    },
    namespace: {
      type: String,
      required: false,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    requestId: {
      type: Number,
      required: true,
    },
    requestOrdo: {
      type: Boolean,
      required: false,
      default: false,
    },
    technician_internal_id: {
      type: Number,
      required: false,
    },
  },
  methods: {
    affectTechnician,
    generateMessage,
    setDispActive,
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    handleRemoveClick() {
      this.affectLoading = true;
      const body = {
        id: null,
        call_number: null,
      };
      this.setDispActive({
        requestId: this.requestId,
        groupId: this.groupId,
        isPaused: this.isPaused,
        isAssigned: this.isAssigned,
      })
        .then(async () => {
          await this.affectTechnician(this.requestId, body)
            .then(() => {
              this.affectedTech = null;
              this.$store.dispatch('requests/setTechnicianAffected', {
                requestId: this.requestId,
                technicianId: null,
              });
              this.$store.dispatch(
                `requests/logs/setUrlParamId`,
                this.requestId
              );
            })
            .catch((err) => {
              this.$store.dispatch(
                'snackbar/setSnackbarOpen',
                catchCRUDError('REJECT', err)
              );
            });
        })
        .catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('FREE', err)
          );
        })
        .finally(() => {
          this.affectLoading = false;
        });
    },
    handleAssignClick(item) {
      this.affectLoading = true;
      this.affectedTech = null;
      const body = {
        id: item.id,
        call_number: item.phone,
      };
      this.setDispActive({
        requestId: this.requestId,
        groupId: this.groupId,
        isPaused: this.isPaused,
        isAssigned: this.isAssigned,
      })
        .then(async () => {
          await this.affectTechnician(this.requestId, body).then(() => {
            this.affectedTech = item;
            this.$store.dispatch('requests/setTechnicianAffected', {
              requestId: this.requestId,
              technicianId: item.id,
            });
            this.$store.dispatch(`requests/logs/setUrlParamId`, this.requestId);
          });
        })
        .catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('FREE', err)
          );
        })
        .finally(() => {
          this.affectLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      last_affected_tech: 'technicians/current',
      loading: 'technicians/isLoadingCurrent',
      isModalOpen: 'modal/isOpen',
    }),
  },
  watch: {
    isModalOpen(newVal) {
      if (!newVal && this.affectedTech !== this.technician_internal_id) {
        this.$store.dispatch('requests/refreshItems');
      }
    },
    requestId() {
      this.affectedTech = null;
    },
    technician_internal_id: {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch('technicians/initCurrent', newVal);
        }
      },
      immediate: true,
    },
    last_affected_tech(newVal) {
      if (newVal) {
        this.affectedTech = newVal;
      }
    },
  },
  data() {
    return {
      affectedTech: null,
      affectLoading: false,
    };
  },
};
</script>
<style scoped>
@keyframes glowing {
  0% {
    background-color: #87c2ec;
    box-shadow: 0 0 5px #1e82ca;
  }
  50% {
    background-color: #87c2ec;
    box-shadow: 0 0 20px #1e82ca;
  }
  100% {
    background-color: #87c2ec;
    box-shadow: 0 0 5px #1e82ca;
  }
}
.buttonTrans {
  animation: glowing 1300ms infinite;
}
</style>
